import { map } from 'rxjs/operators';
import { Store } from './../store';
import { ApiService } from './../services/api.service';
import { AuthService } from './../services/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GalleryService {

    env = environment;


    pagination = {
        searchTerm: '',
        fileType: '',
        limit: 25,
        limits: [5, 10, 25, 50],
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
        sort: 'docs.friendlyName',
        sorts: [
            { ID: 'docs.friendlyName ASC', name: 'Name A-Z' },
            { ID: 'docs.friendlyName DESC', name: 'Name Z-A' },
            { ID: 'docs.created ASC', name: 'Created Oldest' },
            { ID: 'docs.created DESC', name: 'Created Newest' }
        ]
    };

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private apiService: ApiService,
        private store: Store,
    ) { }

    getAll() {
        return this.http.get(this.env.apiPath + 'cms/gallery', this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
                return data;
            }));
    }


    get(id) {
        return this.http.get(this.env.apiPath + 'cms/gallery/' + id, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
                return data;
            }));
    }

    getGalleryImages(id) {
        return this.http.get(this.env.apiPath + 'cms/gallery/images/' + id, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
                return data;
            }));
    }

    create(gallery) {
        const dataToSend = {
            gallery,
            user: this.store.selectForLocal('user'),
        }
        return this.http.post(this.env.apiPath + 'cms/gallery', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
                return data;
            }));
    }

    update(gallery) {
        const dataToSend = {
            gallery,
            user: this.store.selectForLocal('user'),
        }
        return this.http.put(this.env.apiPath + 'cms/gallery', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
                return data;
            }));
    }

    delete(id) {
        return this.http.delete(this.env.apiPath + 'cms/gallery/' + id, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
                return data;
            }));
    }

    deleteImage(id) {
        return this.http.delete(this.env.apiPath + 'cms/gallery/images/' + id, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
                return data;
            }));
    }

    saveImageMeta(image, repeatForAll) {
        const dataToSend = {
            image,
            repeatForAll,
            user: this.store.selectForLocal('user'),
        }
        return this.http.put(this.env.apiPath + 'cms/gallery/images', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
                return data;
            }));
    }

    updateSortOrder(images) {
        const dataToSend = {
            images
        };
        return this.http.post(this.env.apiPath + 'cms/gallery/images/sort', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
                return data;
            }));
    }

}
